import {BasicItem, RegistryFeature} from 'auth/capabilities/CapabilityFeatureConstants';
import {isFeatureEnabled} from 'auth/feature-enablement/FeatureStatus';
import BenchlingConfig from 'BenchlingConfig';

export default function isBatchesEnabled(item?: BasicItem): boolean {
  return (
    BenchlingConfig.ENABLE_BATCHES && isFeatureEnabled({feature: RegistryFeature.REGISTRY_BATCHES, item})
  );
}
